// extracted by mini-css-extract-plugin
export default {"section":"Home_section__uZuiO","card":"Home_card__+O6lb","cardImage":"Home_cardImage__95gM6","fabIconSection":"Home_fabIconSection__2dZo+","fabIcon":"Home_fabIcon__zslTS"};